import { useQuery } from "@tanstack/react-query";
import { GET_REGIONS } from "@/constants/Query";
import { apiRequest } from "@/utils/apiRequest";
import { IRegion } from "@/types/apiResponse.types";
import { useTheme } from "@/context/Theme.context";
import { Theme } from "@/enums";

export const useGetRegionsRequest = () => {
  const theme = useTheme();
  return useQuery<{
    data: {
      data: IRegion[];
    };
  }>({
    queryKey: [GET_REGIONS],
    queryFn: () => apiRequest(GET_REGIONS, "get"),
    enabled: theme !== Theme.GEORGIA,
  });
};
